module.exports = __webpack_public_path__ + "static/img/introduce_1.09164ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce_1.png
// module id = k8yJ
// module chunks = 1